/* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */
import { useEffect, useState } from 'react';
import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Picture } from '@bwoty-web/ui-kit';
import './roomGallery.scss';

const RoomGallery = ({ gallery, hasNoImage, labels }) => {
  const [selectedImage, setSelectedImage] = useState(0);
  useEffect(() => {
    if (selectedImage !== 0)
      document
        .querySelector('.gw-room-gallery__thumbnail-tab[aria-selected]')
        .focus();
  }, [selectedImage]);
  if (!gallery || !gallery.length) {
    return null;
  }

  return (
    <div className="gw-room-gallery">
      <div
        className="gw-room-gallery__image-wrapper"
        id="gw-room-gallery-image"
      >
        {hasNoImage && (
          <div className="gw-room-gallery__default-image-overlay">
            <span>{labels?.roomImageMissing}</span>
          </div>
        )}
        {gallery[selectedImage] && (
          <>
            <Picture
              sources={gallery[selectedImage]?.sources}
              alt={gallery[selectedImage]?.text}
              lazy
            />
            {gallery[selectedImage]?.text && !hasNoImage && (
              <div className="gw-room-gallery__image-text-wrapper">
                <span className="gw-room-gallery__image-text">
                  {gallery[selectedImage]?.text}
                </span>
              </div>
            )}
          </>
        )}
      </div>
      {gallery.length > 1 && (
        <div
          className="gw-room-gallery__thumbnails"
          aria-controls="gw-room-gallery-image"
        >
          {gallery.map((picture, i) => (
            <button
              type="button"
              onClick={() => setSelectedImage(i)}
              key={uniqid('room-gallery-thumbnail')}
              className="gw-room-gallery__thumbnail-tab"
              {...(i === selectedImage && {
                'aria-selected': true,
              })}
            >
              <img
                className={cx('gw-room-gallery__thumbnails-image', {
                  'gw-room-gallery__thumbnails-image--selected':
                    i === selectedImage,
                })}
                src={picture?.thumbnail}
                alt={picture?.text}
                data-gtm-tag="Accom Room type image"
                loading="lazy"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

RoomGallery.propTypes = {
  gallery: PropTypes.arrayOf(
    PropTypes.shape({
      sources: PropTypes.arrayOf(
        PropTypes.shape({
          srcSet: PropTypes.string,
          type: PropTypes.string,
          media: PropTypes.string,
        }),
      ),
      text: PropTypes.string,
      thumbnail: PropTypes.string,
    }),
  ).isRequired,
  labels: PropTypes.shape({
    roomImageMissing: PropTypes.string,
  }).isRequired,
  hasNoImage: PropTypes.bool,
};

RoomGallery.defaultProps = {
  hasNoImage: false,
};

export default RoomGallery;
